import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import BasicDialog from '@zenbusiness/zui/BasicDialog';

function ShouldLoginDialog({ onClose, onLogin, open, ...delegated }) {
  const { formatMessage } = useIntl();

  return (
    <BasicDialog
      open={open}
      primaryAction={{
        clickstreamProps: {
          elementName: 'should_login_dialog_primary_action'
        },
        'data-testid': 'should-login-dialog-primary-action',
        label: formatMessage({ id: 'shopping.component.accountExists.dialog.primaryAction' }),
        onClick: onLogin
      }}
      secondaryAction={{
        clickstreamProps: {
          elementName: 'should_login_dialog_secondary_action'
        },
        'data-testid': 'should-login-dialog-secondary-action',
        label: formatMessage({ id: 'shopping.component.accountExists.dialog.secondaryAction' })
      }}
      subtitle={formatMessage({ id: 'shopping.component.accountExists.dialog.subtitle' })}
      title={formatMessage({ id: 'shopping.component.accountExists.dialog.title' })}
      onClose={onClose}
      {...delegated}
    >
      <FormattedMessage id="shopping.component.accountExists.dialog.content" />
    </BasicDialog>
  );
}

ShouldLoginDialog.propTypes = {
  /** Should the dialog be open? */
  open: PropTypes.bool,
  /** Callback for closing the dialog. */
  onClose: PropTypes.func,
  /** Callback for login. */
  onLogin: PropTypes.func
};

export default ShouldLoginDialog;
